import usFlag from "../assets/images/flags/us.jpg";
import slovakia from "../assets/images/flags/slovakia.jpg";


const languages = {
  en: {
    label: "English",
    flag: usFlag,
  },
  sk: {
    label: "Slovak",
    flag: slovakia,
  },
}

export default languages;
